/**
 * @voltxampere/ui — Canvas tool contracts (Sprint 12)
 *
 * Per Blueprint §12.6. Sprint 12 ships SelectTool + PanTool only.
 * Sprint 13 will add WireTool / StampTool / ProbeTool against the
 * same `CanvasTool` interface — no API change required.
 *
 * `ToolContext` carries the per-event dependencies the tool
 * needs: viewport for coordinate maths, hit tester for cursor
 * resolution, dirty tracker to schedule redraws, plus the two
 * UI-side state signals (`hoveredNode`, `selectedNodes`).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
/**
 * Toggle helper: add `id` to the selection set if absent, remove
 * if present. Pure — returns a new array, leaves the input alone.
 */
export function toggleSelection(current, id) {
    const idx = current.indexOf(id);
    if (idx < 0)
        return [...current, id];
    return [...current.slice(0, idx), ...current.slice(idx + 1)];
}
//# sourceMappingURL=base.js.map